import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/common/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PricingPage from "@/pages/PricingPage";

import ClientEvent from "@/pages/client/ClientEvent";
import ClientGallery from "@/pages/client/ClientGallery";
import FindMyPhotos from "@/pages/client/FindMyPhotos";
import ClientSelected from "@/pages/client/ClientSelected";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/DashboardHome";
import Events from "@/pages/dashboard/Events";
import CreateEvent from "@/pages/dashboard/CreateEvent";
import EventDetail from "@/pages/dashboard/EventDetail";
import PhotosPage from "@/pages/dashboard/PhotosPage";
import Clients from "@/pages/dashboard/Clients";
import Selections from "@/pages/dashboard/Selections";
import QRCodes from "@/pages/dashboard/QRCodes";
import Analytics from "@/pages/dashboard/Analytics";
import Subscription from "@/pages/dashboard/Subscription";
import Settings from "@/pages/dashboard/Settings";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPhotographers from "@/pages/admin/AdminPhotographers";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminCRM from "@/pages/admin/AdminCRM";
import AdminVideo from "@/pages/admin/AdminVideo";

function App() {
  return (
    <div className="App grain">
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<PricingPage />} />

            <Route path="/event/:eventId" element={<ClientEvent />} />
            <Route path="/event/:eventId/gallery" element={<ClientGallery />} />
            <Route path="/event/:eventId/find" element={<FindMyPhotos />} />
            <Route path="/event/:eventId/selected" element={<ClientSelected />} />

            <Route path="/app" element={<ProtectedRoute role="photographer"><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<DashboardHome />} />
              <Route path="events" element={<Events />} />
              <Route path="events/new" element={<CreateEvent />} />
              <Route path="events/:eventId" element={<EventDetail />} />
              <Route path="photos" element={<PhotosPage />} />
              <Route path="clients" element={<Clients />} />
              <Route path="selections" element={<Selections />} />
              <Route path="qr" element={<QRCodes />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="subscription" element={<Subscription />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="/superadmin" element={<ProtectedRoute role="super_admin"><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="photographers" element={<AdminPhotographers />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="pricing" element={<AdminPricing />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="crm" element={<AdminCRM />} />
              <Route path="video" element={<AdminVideo />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
